/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getInvoices } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

export const useGetInvoicelist = (filters: any) => useQuery({
    staleTime: 300000, // 5 minutes
    cacheTime: 3600000, // 60 minutes
    queryKey: invoiceQueryKeys.invoiceListing(filters),
    queryFn: ({ signal }) => getInvoices({ params: filters, signal }).then((res) => res.data),
  });
